import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue"
import ChatSummary from "@/modules/Missions/components/Details/Chat/ChatSummary.vue"
import ProjectOverview from "@/modules/Missions/components/Details/OverviewCard/OverviewCard.vue"
import ClientInfo from "@/modules/Missions/components/Details/ClientInfo/ClientInfo.vue"
import ScopeOverview from "@/modules/Missions/components/ScopeOverview/ScopeOverview.vue"
import {
  MissionLifecycleFragmentFragment,
  ConsultantMissionLifecycle,
  ClientMissionLifecycleFragmentFragment,
  Client,
} from "@/gql"
import TeamMembers from "@/modules/Missions/components/Details/TeamMembers/TeamMembers.vue"
import SubmitMissionProposal from "@/modules/Missions/components/CalloutCard/SubmitMissionProposal.vue"
import ApproveMissionProposal from "@/modules/Missions/components/CalloutCard/ApproveMissionProposal.vue"
import { useAccountContext } from "@/hooks/useAccountContext"
import ActivitySummary from "../Activity/ActivitySummary.vue"
import { useMissionLifecycleContext } from "@/modules/Missions/hooks/useMissionLifecycleContext"


export default /*#__PURE__*/_defineComponent({
  __name: 'Overview',
  props: {
    mission: null
  },
  setup(__props: any) {

const props = __props as {
  mission:
    | MissionLifecycleFragmentFragment
    | ConsultantMissionLifecycle
    | ClientMissionLifecycleFragmentFragment
}



const { isClient, isStaff } = useAccountContext()
const { refetchQueries } = useMissionLifecycleContext()

const isMissionLifecycle = (
  mission:
    | MissionLifecycleFragmentFragment
    | ConsultantMissionLifecycle
    | ClientMissionLifecycleFragmentFragment
): mission is MissionLifecycleFragmentFragment => {
  return (
    mission.__typename === "MissionLifecycle" || mission.__typename === "ClientMissionLifecycle"
  )
}

const missionLifecycle = computed(() => (isMissionLifecycle(props.mission) ? props.mission : null))

const clientInfo = computed(() => {
  return props.mission?.client as Client
})

const showSubmitProposalCallout = computed(() => {
  if (isMissionLifecycle(props.mission)) {
    return (
      isStaff &&
      props.mission?.missionPricingProposal &&
      props.mission?.missionContract?.missionContractPayments.length &&
      !props.mission?.missionProposal?.clientApproval
    )
  }

  return false
})

return { __sfc: true,props, isClient, isStaff, refetchQueries, isMissionLifecycle, missionLifecycle, clientInfo, showSubmitProposalCallout, ChatSummary, ProjectOverview, ClientInfo, ScopeOverview, TeamMembers, SubmitMissionProposal, ApproveMissionProposal, ActivitySummary }
}

})